import React from "react";
import NewsroomMediaThree from "../component/NewsroomMediaThree";

function NewsroomMediaThreeContainer() {
  return <NewsroomMediaThree />;
}

export default NewsroomMediaThreeContainer;
